<template>
  <v-tooltip top :disabled="mostrarTooltip">
    <v-icon
      :id="id"
      :color="color"
      :disabled="deshabilitado"
      @click.stop="onclick"
      slot="activator"
    >
      <slot></slot>
    </v-icon>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'Icono',
  props: {
    id: {
      type: String
    },
    color: {
      type: String,
      default: 'info'
    },
    deshabilitado: {
      type: Boolean,
      default: false
    },
    payload: {
      type: Object,
      default: null
    },
    tooltip: {
      type: String,
      default: ''
    }
  },
  methods: {
    onclick() {
      this.$emit('click', this.payload);
    }
  },
  computed: {
    mostrarTooltip() {
      return this.tooltip == null || this.tooltip === '' ? true : false;
    }
  }
};
</script>
